module.exports = __webpack_public_path__ + "poppins-regular_0-webfont.e2897034ef3d6848c85a.eot";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/poppins-regular_0-webfont.eot
// module id = ../../../../../src/assets/fonts/poppins-regular_0-webfont.eot
// module chunks = 2